import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  constructor(
    private platform: Platform,
    private firebaseAnalytics: FirebaseAnalytics
  ) {
  }
  
  firebaseScreenName(str: string) {
    this.platform.ready().then(() => {
      if (!this.platform.is('cordova')) {
        return;
      }
      
      this.firebaseAnalytics.setCurrentScreen(str)
        .then(() => { console.log('FirebaseAnalytics setCurrentScreen:', str); })
        .catch(err => { console.log('Error FirebaseAnalytics setCurrentScreen', err); });
    });
  }

  firebaseLogEvent(str: string, obj: any) {
    this.platform.ready().then(() => {
      if (!this.platform.is('cordova')) {
        return;
      }
      
      this.firebaseAnalytics.logEvent(str, obj)
        .then(() => { console.log('FirebaseAnalytics logEvent:', str); })
        .catch(err => { console.log('Error FirebaseAnalytics logEvent', err); });
    });
  }

}

